import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=2d56be66&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=ts"
export * from "./ProductTile.vue?vue&type=script&lang=ts"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=2d56be66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56be66",
  null
  
)

export default component.exports